<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="old_password" label="原始密码" name="old_password" >
          <a-input v-model:value="form.old_password" type="password" />
        </a-form-item>
           <a-form-item ref="new_password" label="新密码" name="new_password" >
          <a-input v-model:value="form.new_password" type="password" />
        </a-form-item>
           <a-form-item ref="confirm_password" label="再次确认" name="confirm_password" >
          <a-input v-model:value="form.confirm_password" type="password" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
          <a-button type="primary" v-has:passwordEdit="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>

<script>
import { ref, reactive, toRefs, inject } from 'vue';
import {editPassword} from '@/api/system'
import { Modal } from 'ant-design-vue';
import { iscode } from '../../../utils/app';
// 初始化默认筛选项数值
let defForm = {
  old_password: '',
  new_password:'',
  confirm_password:''
};
export default {
  components: {},
  setup() {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      labelCol: { span: 2 },
      wrapperCol: { span: 5},
      value:[],
      rules: {
        old_password: [
          {
            required: true,
            message: '请输入原始密码',
            trigger: 'blur',
          },
        ],
         new_password: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
        ],
         confirm_password: [
          {
            required: true,
            message: '请再次确认密码',
            trigger: 'blur',
          },
        ],
      },
    });
    const $router=inject('$router')
    const ruleForm = ref();
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(() => {
         Modal.confirm({
          centered: true,
          content: "确定要修改密码?确定之后密码将被修改!",
          onOk: async () => {
            let result = await editPassword({
              ...form.value
            }).then((res) => res.data).catch((error) => error);
            if (iscode(result, true)) {
            localStorage.removeItem("token")
             $router.push({ path: '/login' });
            }
          },
        });
        })
        .catch((error) => {
          console.log('error', error);
        });
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
    };
  },
};
</script>
